import { render, staticRenderFns } from "./content-assessor.vue?vue&type=template&id=b60e0cce"
import script from "./content-assessor.vue?vue&type=script&lang=js"
export * from "./content-assessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports